import { GET_BLOG_CATEGORY_AND_SUBCATEGORY } from "../../store/constants/blogConstants";
import { getRequest } from "../../utils/request";
import { GET_HOME_PAGE_DATA, GET_OLD_HOME_PAGE_DATA } from "./constants";

export const getHomeDataAction = (data) => (dispatch) => {
  getRequest("get-home-details", data, dispatch, GET_HOME_PAGE_DATA);
};

export const getOldHomeData = (data) => (dispatch) => {
  getRequest("home-cms-resources", data, dispatch, GET_OLD_HOME_PAGE_DATA);
};

export const getBlogCtegoryAndSubcategory = (data) => (dispatch) => {
  getRequest("get-blog-categories", data, dispatch, GET_BLOG_CATEGORY_AND_SUBCATEGORY);
};
